// extracted by mini-css-extract-plugin
module.exports = {"pageBanner":"ListPage_pageBanner__8IXq8","content":"ListPage_content__NSrCL"};